import { Component } from '@angular/core';

@Component({
	templateUrl: './adblock-dialog.component.html',
	standalone: false,
})
export class AdblockDialogComponent { }
